"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handle = handle;
exports.handleEE = void 0;
var _contextualEe = require("./contextual-ee");
/*
 * Copyright 2020 New Relic Corporation. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

var handleEE = exports.handleEE = _contextualEe.ee.get('handle');
function handle(type, args, ctx, group, ee) {
  if (ee) {
    ee.buffer([type], group);
    ee.emit(type, args, ctx);
  } else {
    handleEE.buffer([type], group);
    handleEE.emit(type, args, ctx);
  }
}